<ng-container *ngIf="show">
    <mat-progress-bar [mode]="mode" [value]="progress" class="custom-progress-bar"></mat-progress-bar>
</ng-container>
<!-- -->